export type GridTieOperatingMode = 'INVALID' | 'MAX_BACKUP_RESERVE' | 'SELF_CONSUMPTION' | 'TOU_SAVINGS';
export type StormMode = 'INVALID' | 'OFF' | 'ON';
export type OperatingModeOverride = 'INVALID' | 'OFF_GRID' | 'STANDBY';

export type EnergyMode = 'TOU' | 'LOW_POWER' | 'STORM' | 'BATTERY_MAX' | 'SELF_CONSUMPTION';

export enum EnergyModeType {
  TOU = 'TOU',
  LOW_POWER = 'LOW_POWER',
  STORM = 'STORM',
  BATTERY_MAX = 'BATTERY_MAX',
  SELF_CONSUMPTION = 'SELF_CONSUMPTION',
}

export type EnergyModesResponse = {
  energy_mode: EnergyMode;
  pending?: {
    energy_mode: EnergyMode;
  };
};

export type EnergyModePayload = {
  energy_mode: EnergyMode;
};
